export const ASSETS = "/collectionManager/assets";
